import { useState, useEffect } from 'react';
import AdminGate from './AdminGate';

/**
 * Hôte GLOBAL du portail admin. Monté une seule fois au niveau de l'app (pas dans
 * AdminLayout), il écoute l'événement 'monquiz:admin_gate_required' émis par
 * l'intercepteur api.js (403 reason gate_required) et affiche la modale de saisie
 * du mot de passe — depuis n'importe quelle page (ex. impersonation depuis le menu
 * header, hors /gestion).
 */
export default function AdminGateHost() {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const handler = () => setOpen(true);
        window.addEventListener('monquiz:admin_gate_required', handler);
        return () => window.removeEventListener('monquiz:admin_gate_required', handler);
    }, []);
    return open ? <AdminGate /> : null;
}
